
//const BACKEND_URL_BASE_API = 'https://testuploadbackend-production.up.railway.app'
const BACKEND_URL_BASE_API = 'http://localhost:5978'

module.exports = BACKEND_URL_BASE_API